export default {
  POLL_GETPOLL: '/api/vote/info',                                         // 获取投票题目

  POLL_VOTE: '/api/vote/poll',                                            // 投票

  POLL_LIST: '/api/vote/list',                                            // 投票列表

  PLAZA_POLL_LIST: '/api/banner/banners',                                 // 活动广场banner

  CHECK_SIGN: '/api/check/sign',                                          // 签到

  CHECK_SIGNRECORD: '/api//check/signRecord',                             // 签到记录

  PLAZA_CONTENT_CLASS: '/api/activityContent/getContentClass',            // 查询专题（活动广场首页、内容列表）

  PLAZA_CONTENT_SAVE: '/api/activityContent/save',                        // 提交内容/保存草稿

  PLAZA_CONTENT_LIST: '/api/activityContent/getContentList',              // 2.查询内容列表（内容列表、达人专栏、我的内容列表）

  PLAZA_CONTENT_INFO: '/api/activityContent/getContent',                  // 3.查询内容详情

  PLAZA_CONTENT_RECOMMEND: '/api/activityContent/getContentRecommend',    // 4.内容推荐列表 

  PLAZA_CONTENT_DELETE: '/api/activityContent/delete',                    // 6.删除内容/草稿

  PLAZA_SQUARE_USERINFO: '/api/check/squareUserInfo',                     // 7.用户信息

  PLAZA_MY_CONTENTLIST: '/api/activityContent/getMyContentList',          // 7.3.我的内容列表

  PLAZA_MY_USERINFO: '/api/activityContent/getUserInfo',                  // 7.3.我的内容列表

  PLAZA_GET_CONTENT: '/api/activityContent/getContent',                   // 查询内容详情
  
  PLAZA_CONTENT_RANKING: '/api/activityContent/getContentRanking',        // 5.分享达人
  
  PLAZA_POST_RANKING: '/api/activityContent/getPostRanking',              // 话题贡献排行榜

  PLAZA_GET_RECOMMEND: '/api/activityContent/getContentRecommend',        // 6.内容推荐列表

  PLAZA_GET_DRAFT: '/api/activityContent/getDraft',                       // 获取草稿

  PLAZA_CUR_LIST: '/api/common/task/curlist',                             // 活动广场获取任务列表

  PLAZA_POSTS_READ: '/api/posts/read',                                    // 阅读帖子

  PLAZA_ACTIVITY_LIST: '/api/activityContent/getActivityList',             // 首页集合

  COMMENT_LIST: '/api/web/comment/list',                  // 评论列表
   
  COMMENT_DETAIL: '/api/web/comment/get',                    // 评论
  
  PRAISE_SAVE: '/api/web/praise/save',            // 点赞和取消点赞

  COMMENT_ADD: '/api/web/comment/add',                  // 发表评论

  WECHAT_BIND: '/api/user/wechat/bind',               // 绑定微信
  
  POSTS_LIST: '/api/posts/list',                         // 动态列表 
  
  TOPIC_INFO: '/api/common/info',                       // 话题详情 

  PLAZA_POSTS_INFO: '/api/posts/info',                  // 活动广场话题详情
  
  POST_PUBLISH: '/api/posts/publish',                     // 发布动态

  PLAZA_GET_ACTIVITY: '/api/activityContent/getActivitySquare', // 获取广场名称

  PLAZA_COMMON_ACTIVITIES: '/api/common/contest/activities',    // 所有活动广场

  TOPIC_LIST: '/api/common/webList',                       // 话题列表 

  MESSAGE_UNREADALL: '/api/pushMessage/unReadAll'                       // 未读消息总数

}



// WEBPACK FOOTER //
// ./src/assets/api/common/event-plaza.js